import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { DeliveryAddress, DeliverySlot } from '@cinch/oxd-redux/checkout/src/reducers/delivery'

const ORDER_SERVICE_URL = getEnv(Env.OrderServiceUrl)
const order = axios.create({ baseURL: `${ORDER_SERVICE_URL}/order` })

export interface PersonalDetailsData {
  firstName: string
  lastName: string
  email: string
  contactTelephoneNumber: string
}

/*
 * Create a brand new order for a vehicle
 */
export const create = (vehicleId: string, data: PersonalDetailsData) => {
  return order.post<Cinch.OrderDetailsResponse>('/create', { vehicleId, ...data })
}

/*
 * Update the personal details of an existing order
 */
export const updateDetails = (orderId: string, data: PersonalDetailsData) => {
  return order.post<Cinch.OrderDetailsResponse>(`${orderId}/personal-details`, data)
}

/*
 * Add/Update the delivery address on an existing order
 */
export const addDeliveryAddress = (orderId: string, address: DeliveryAddress) => {
  return order.post<Cinch.OrderDetailsResponse>('/add-address', { orderId, ...address })
}

export const addDeliverySlot = (orderId: string, slot: DeliverySlot, deliveryInstructions?: string) => {
  return order.post<Cinch.OrderDetailsResponse>('/add-delivery', {
    orderId,
    start: slot.start.toString(),
    end: slot.end.toString(),
    date: slot.date,
    deliveryInstructions,
  })
}

export const addPartExchangeValuation = (orderId: string, valuationId: string) => {
  return order.post<Cinch.OrderDetailsResponse>('/add-part-ex', {
    orderId,
    valuationId,
  })
}

export const getOrderDetails = (orderId: string) => {
  return order.request<Cinch.OrderDetailsResponse>({
    url: `/${orderId}`,
    method: 'GET',
  })
}

export interface ServicePlanQuote {
  AgreementId: string
  AgreementReference: string
  PlanName: string
  FinancialDetails: {
    Total: number
  }
}

interface ServicePlanResponse {
  servicePlans: ServicePlanQuote[]
}

export const getOrderServicePlans = (vrm: string) =>
  axios.get<ServicePlanResponse>(`${ORDER_SERVICE_URL}/service-plans/${vrm}`)
